/**
 * контроллер для окна сохранения зоны
 * @module PageGeo/Controller/SaveWnd
 */
import Onedeck from 'onedeck'
import * as webix from 'webix'
import SaveWndUI from 'PageGeo/views/save.wnd.ui'
import * as geoService from 'API/geoService'

export default class SaveWnd {
  constructor(initObj) {
    this.ui = new SaveWndUI()
    this.id = this.ui.id
    this.api = initObj.apiUrl
    this.wnd = webix.ui(this.ui)
    webix.extend($$(this.id), webix.ProgressBar)
    this.eventHandler()
  }

  /**
   * Обработчик событий
   */
  eventHandler() {
    $$(`${this.id}BtnClose`).attachEvent('onItemClick', () => this.hide())
    $$(`${this.id}BtnSave`).attachEvent('onItemClick', () => {
      if (this.area && this.area.id) {
        this.update()
      } else {
        this.save()
      }
    })
  }

  loadData = async () => {
    $$(this.id).showProgress({
      type: 'icon'
    })

    if (this.area) {
      $$(`${this.id}Name`).setValue(this.area.name)
      $$(`${this.id}Notes`).setValue(this.area.description)
    }

    $$(this.id).hideProgress()
  }

  save = async () => {
    $$(this.id).showProgress({
      type: 'icon'
    })
    if (this.coordinates && this.coordinates.length) {
      const paramArea = {
        type: 'global',
        is_hidden: false,
        name: $$(`${this.id}Name`).getValue(),
        description: $$(`${this.id}Notes`).getValue()
      }
      const paramShape = {
        geometry: this.coordinates.map(c => ({
          latitude: c[0],
          longitude: c[1]
        }))
      }
      const responseArea = await geoService.saveParamArea(JSON.stringify(paramArea))

      const area = responseArea.data
      await geoService.saveParamShape(area.id, JSON.stringify(paramShape))
      this.wnd.hide()

      location.href = "#/geo"
    }

    $$(this.id).hideProgress()
  }

  update = async () => {
    $$(this.id).showProgress({
      type: 'icon'
    })
    if (this.coordinates && this.coordinates.length) {
      const paramArea = {
        id: this.area.id,
        type: 'global',
        is_hidden: false,
        name: $$(`${this.id}Name`).getValue(),
        description: $$(`${this.id}Notes`).getValue()
      }
      const responseArea = await geoService.updateParamArea(this.area.id, JSON.stringify(paramArea))
      const area = responseArea.data
      const shapeId = this.area.shapes && this.area.shapes[0] && this.area.shapes[0].shape_id
      if (shapeId) {
        const paramShape = {
          area_id: this.area.id,
          geometry: this.coordinates.map(c => ({
            latitude: c[0],
            longitude: c[1]
          })),
          shape_id: shapeId
        }
        await geoService.updateParamShape(shapeId, JSON.stringify(paramShape))
      } else {
        const paramShape = {
          geometry: this.coordinates.map(c => ({
            latitude: c[0],
            longitude: c[1]
          }))
        }
        await geoService.saveParamShape(area.id, JSON.stringify(paramShape))
      }

      this.wnd.hide()

      location.href = "#/geo"
    }

    $$(this.id).hideProgress()
  }

  /**
   * Показать окно
   */
  show(data) {
    this.wnd.show()
    this.coordinates = data.coordinates
    this.area = data.area || null
    this.loadData()
  }

  /**
   * Закрыть окно
   */
  hide() {
    this.wnd.hide()
  }

  /**
   * Деструктор
   */
  destroy() {
    this.wnd.destructor()
    delete this
  }
}
